import axios from 'axios';
import { AuthService, generateTraceParent } from 'br2s-ui-common-utils-02';
const Axios = axios.create({});
Axios.interceptors.request.use((config) => {
    if (config.method === 'get') {
        // Explicitly pass empty data to persist Content-Type as application/json
        // eslint-disable-next-line no-param-reassign
        config.data = {};
    }
    config.headers.set('Content-Type', 'application/json');
    config.headers.set('Access-Control-Allow-Origin', process.env.REACT_APP_API_ORIGIN_URL);
    config.headers.set('traceparent', generateTraceParent());
    if (config.withCredentials !== false) {
        // eslint-disable-next-line no-param-reassign
        config.withCredentials = true;
    }
    return config;
});
// setting the refresh token
Axios.interceptors.response.use(undefined, async (error) => {
    if (AuthService.isTokenExpired(error)) {
        // eslint-disable-next-line arrow-body-style
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-promise-executor-return
            return AuthService.handleTokenExpiredEz()
                .then((result) => (result ? resolve : reject)(axios(error.config)))
                .catch((e) => reject(e));
        });
    }
    return Promise.reject(error);
});
export default Axios;
